// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.MuiList-root::-webkit-scrollbar {
  width: 5px;
}

ul.MuiList-root::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 7px rgba(0, 0, 0, 0.2);
}

ul.MuiList-root::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}

.full-calendar-wrapper {
  height: 100%;
  width: 100%;
  color: #262626;
}

.full-calendar-wrapper .fc-h-event {
  background-color: transparent;
  border-color: transparent;
}

.full-calendar-wrapper .fc-toolbar {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.full-calendar-wrapper .fc-toolbar-title {
  flex-grow: 1 !important;
}

.full-calendar-wrapper .fc-prev-button,
.full-calendar-wrapper .fc-next-button {
  margin: 0 5px !important;
}

.full-calendar-wrapper .fc-scrollgrid-section-header {
  background-color: #45a735;
  color: white;
  font-size: small;
}

.full-calendar-wrapper .fc-h-event .fc-event-title-container {
  background-color: #45a735;
  font-weight: 200;
}

.full-calendar-wrapper .fc-toolbar-title {
  margin: 0 24px;
}

.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary {
  background-color: transparent;
  color: var(--colors-textLight);
  border-color: var(--colors-textLight);
  border-radius: 50%;
  padding: 6px;
  font-size: 10px;

}

.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary.disable {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.fc-event-start {
  margin-left: 0px;
}

.fc-event-end {
  margin-right: 0px;
}

.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary:focus,
.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary:hover {
  color: white;
  background-color: var(--colors-themeDefault);
  border-color: var(--colors-themeDefault);
}

/* .full-calendar-wrapper .fc-daygrid-day-frame .fc-scrollgrid-sync-inner {
  background-color: var(--colors-themeDefault);
} */
.full-calendar-wrapper .fc .fc-daygrid-day.fc-day-today {
  background-color: #F2F3F6;
}

.fc-day :has(div.fc-daygrid-event-harness) {
  background-color: #EEFFEC;
}

.full-calendar-wrapper .fc-event-check {
  background-color: #EEFFEC;
}

@media (max-width: 559px) {
  .fc-daygrid-more-link {
    font-size: 11px;
    padding-top: 5px !important;
  }
}

.disableDate a {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/routes/Agency/CreateGigOrder/JobEditor/Steps/ScheduleStep/ScheduleSection/index.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;GAEG;AACH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;AACd","sourcesContent":["ul.MuiList-root::-webkit-scrollbar {\n  width: 5px;\n}\n\nul.MuiList-root::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 7px rgba(0, 0, 0, 0.2);\n}\n\nul.MuiList-root::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n}\n\n.full-calendar-wrapper {\n  height: 100%;\n  width: 100%;\n  color: #262626;\n}\n\n.full-calendar-wrapper .fc-h-event {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.full-calendar-wrapper .fc-toolbar {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.full-calendar-wrapper .fc-toolbar-title {\n  flex-grow: 1 !important;\n}\n\n.full-calendar-wrapper .fc-prev-button,\n.full-calendar-wrapper .fc-next-button {\n  margin: 0 5px !important;\n}\n\n.full-calendar-wrapper .fc-scrollgrid-section-header {\n  background-color: #45a735;\n  color: white;\n  font-size: small;\n}\n\n.full-calendar-wrapper .fc-h-event .fc-event-title-container {\n  background-color: #45a735;\n  font-weight: 200;\n}\n\n.full-calendar-wrapper .fc-toolbar-title {\n  margin: 0 24px;\n}\n\n.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary {\n  background-color: transparent;\n  color: var(--colors-textLight);\n  border-color: var(--colors-textLight);\n  border-radius: 50%;\n  padding: 6px;\n  font-size: 10px;\n\n}\n\n.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary.disable {\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.fc-event-start {\n  margin-left: 0px;\n}\n\n.fc-event-end {\n  margin-right: 0px;\n}\n\n.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary:focus,\n.full-calendar-wrapper .fc-toolbar-chunk .fc-button-primary:hover {\n  color: white;\n  background-color: var(--colors-themeDefault);\n  border-color: var(--colors-themeDefault);\n}\n\n/* .full-calendar-wrapper .fc-daygrid-day-frame .fc-scrollgrid-sync-inner {\n  background-color: var(--colors-themeDefault);\n} */\n.full-calendar-wrapper .fc .fc-daygrid-day.fc-day-today {\n  background-color: #F2F3F6;\n}\n\n.fc-day :has(div.fc-daygrid-event-harness) {\n  background-color: #EEFFEC;\n}\n\n.full-calendar-wrapper .fc-event-check {\n  background-color: #EEFFEC;\n}\n\n@media (max-width: 559px) {\n  .fc-daygrid-more-link {\n    font-size: 11px;\n    padding-top: 5px !important;\n  }\n}\n\n.disableDate a {\n  opacity: 0.3;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
